module.exports = __webpack_public_path__ + "static/media/Instagram-color.6fb90273.svg";